/**
 * Subdomain-based redirect for Super Admin.
 * When user visits superadmin.yourdomain.com, ensure they go to Super Admin login.
 * When user visits main domain and tries /superadmin/*, optionally redirect to superadmin subdomain.
 *
 * Set REACT_APP_SUPERADMIN_SUBDOMAIN=superadmin and REACT_APP_PUBLIC_URL=https://nacsoftwareandtechsolution.com
 * in production to enable subdomain redirects.
 */
export function getSubdomain(): string | null {
  if (typeof window === 'undefined') return null;
  const hostname = window.location.hostname;
  // Skip localhost and IPs
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.')) {
    return null;
  }
  const parts = hostname.split('.');
  if (parts.length >= 2) {
    const sub = parts[0].toLowerCase();
    if (sub && sub !== 'www') return sub;
  }
  return null;
}

export function shouldRedirectToSuperAdmin(): boolean {
  const subdomain = getSubdomain();
  const superadminSub = (process.env.REACT_APP_SUPERADMIN_SUBDOMAIN || 'superadmin').toLowerCase();
  return subdomain === superadminSub;
}

export function getSuperAdminRedirectUrl(): string | null {
  const publicUrl = process.env.REACT_APP_PUBLIC_URL || '';
  const superadminSub = (process.env.REACT_APP_SUPERADMIN_SUBDOMAIN || 'superadmin').toLowerCase();
  if (!publicUrl) return null;
  try {
    const url = new URL(publicUrl);
    return `https://${superadminSub}.${url.hostname}/superadmin/login`;
  } catch {
    return null;
  }
}
